import { Store } from "redux";
import { AlightCustomSettingsType } from "../../settings/alight-custom-settings";
import { AlightStateType } from "../../types/alight-state";

export default class LaunchPointMutator {
    _settings: AlightCustomSettingsType;
    _store: Store<AlightStateType> | undefined;

    constructor(settings: AlightCustomSettingsType) {
        this._settings = settings;
    }

    initialize(store: Store<AlightStateType>) {
        this._store = store;
    }

    getMutator(){
        return (parameters: any = {}) => {
            //have to add this to turn off this feature so that we can proceed to prod until we can get iva as a service completed
            return parameters;

            //  for backward compatability - we don't want to hide launch point if IVA as a Service is not enabled
            if (!window.enableIVAasService){
                return parameters;
            }

            const currentState = this._store?.getState();
            if (currentState == null) {
                return parameters;
            }
            
            if(currentState?.Window &&
                currentState?.Window.initializationData &&
                currentState?.Window.initializationData.initDataRetrieved &&
                currentState?.Window.initializationData.initDataRetrieved.benefitCenterName) {

                return parameters;
            }

            // in Minimized state
            parameters.className = this._settings.classNames.launchPointDisabled;

            return parameters;
        };
    }


}



// WEBPACK FOOTER //
// ./modules/mutators/launchPointMutator.ts